import React, { useEffect, useState } from "react";
import {
	PanelBar,
	PanelBarItem,
	PanelBarUtils,
	PanelBarSelectEventArguments,
	MenuItem,
} from "@progress/kendo-react-layout";
//import { MenuPageName, PageGroup, PageTypePath } from "utils/pages";
import { PageTypePath } from "utils/pages";

import { getMenuApi } from "api/menu";

import { Font, ICON_NAMES } from "utils/constant";
import { useNavigate, useParams } from "react-router";
import { getCatchSignRegisterUserApi } from "api/sign";
import { getUserUniqueStringApi } from "api/administration";
import { useMenuItemStore } from "store/menuItem";
import { UserMenuItem } from "interface/userMenuItem";

const SideMenuBar: React.FC<{
	currentPage: string;
}> = ({ currentPage }) => {
	const navigate = useNavigate();
	const { menuItems, setMenuItem } = useMenuItemStore();
	const [selectedItem, setSelectedItem] = useState({ id: "", expandId: [""] });
	const [menuData, setMenuData] = React.useState<UserMenuItem[]>([]);

	let { path } = useParams();

	const handleOnselect = (e: PanelBarSelectEventArguments) => {
		const path = e.target.props.path;
		const id = e.target.props.id;

		setSelectedItem({
			expandId: e.expandedItems,
			id: e.target.props.id as any,
		});

		if (path === PageTypePath.Home) {
			navigate(`/`);
			return;
		}

		if (id === "337") {
			const newWindow = window.open('', '_blank');

			getCatchSignRegisterUserApi()
				.then((response) => {
					if (newWindow) {
						newWindow.location.href = response;
					}
				})
				.catch((error) => {
					if (newWindow) {
						newWindow.close();
					}
					console.log(error);
				});

			return;
		}

		if (id === "339") {
			console.log('auction');

			const newWindow = window.open('', '_blank');

			getUserUniqueStringApi()
				.then((response) => {
					if (newWindow) {
						newWindow.location.href = path + '?id=' + response;
					}
				})
				.catch((error) => {
					console.log(error);
					if (newWindow) {
						newWindow.close();
					}
				});

			return;
		}

		if (path) {
			if (path.startsWith("http")) {
				window.open(path, "_blank");
			} else {
				navigate(`/${path}`);
			}
		}
	};

	useEffect(() => {
		getMenu();
		// handleMenuUpdate();
	}, []);

	useEffect(() => {
		handleMenuUpdate();
	}, [menuItems]);

	const getMenu = () => {
		getMenuApi()
			.then((response) => {
				setMenuItem(
					response.map((item) => ({
						...item,
						id: item.id.toString(),
						children: item.children
							? item.children.map((child) => ({
									...child,
									id: child.id.toString(),
								}))
							: null,
					})) as any,
				);
			})
			.catch((err) => {
				console.log(err);
			});
	};

	const handleMenuUpdate = () => {
		let data = menuItems;
		// data = data.map((item) => ({ ...item, id: item.id.toString() })) as any;
		try {
			if (path) {
				data.forEach((item) => {
					let expand = false;

					if (item.path === path) {
						item.selected = true;

						setSelectedItem({ id: item.id as any, expandId: [item.id] as any });
					} else {
						if (item.children) {
							item.children.forEach((child) => {
								if (child.path === path) {
									setSelectedItem({
										id: child.id as any,
										expandId: [item.id] as any,
									});

									// child.selected = true;
									// expand = true;
								}
							});

							// if (expand) {
							// 	item.expanded = true;
							// }
						}
					}
				});
			} else {
				if (data[0] !== undefined) {
					setSelectedItem({
						id: data[0].id as any,
						expandId: [data[0].id] as any,
					});
				} else {
					setSelectedItem({
						id: "0",
						expandId: ["0"],
					});
				}
				// data[0].selected = true;
			}
			setMenuData(data);
		} catch (error) {
			console.log("error", error);
		}
	};

	const handleSelectedData = () => {
		// Create deep copies for each item so that state is not mutated (handles 3-level nesting)
		let data = menuData.map((item) => ({
			...item,
			children: item.children
				? item.children.map((child) => ({
						...child,
						children: child.children
							? child.children.map((grandchild) => ({ ...grandchild }))
							: undefined,
					}))
				: undefined,
		}));

		data = data.filter((item) => {
			if (item.children && item.children.length > 0) {
				// Filter children based on status
				item.children = item.children.filter((child) => {
					if (child.children && child.children.length > 0) {
						const children = child.children.filter(
							(grandchild) => grandchild.status !== 2,
						);
						child.children = children.length > 0 ? children : undefined;
					}
					return child.status !== 2;
				});
				return item.children.length > 0;
			}
			return item.status !== 2;
		});

		return data.map((item) => {
			if (!path) {
				if (
					item.path === PageTypePath.Home &&
					selectedItem.id === item.id.toString()
				) {
					return {
						...item,
						imageUrl: `/icon/${ICON_NAMES.HomeWhite}.svg`,
					};
				}
			}
			if (selectedItem.id === item.id.toString()) {
				return {
					...item,
					imageUrl: item.imageUrlTransparent,
				};
			}
			return item;
		});
	};

	const components = PanelBarUtils.mapItemsToComponents(
		handleSelectedData() as any,
	);
	// if (!user) return <div></div>;
	return (
		<PanelBar
			style={{
				top: "4px",
				right: "0px",
				backgroundColor: "transparent",
				fontFamily: Font.WorkSans,
				fontSize: "15px",
				border: "1px solid transparent",
			}}
			onSelect={handleOnselect}
			expandMode="single"
			selected={selectedItem.id}
			expanded={selectedItem.expandId}
			isControlled={true}
			keepItemsMounted={true}
			children={components}
		/>
	);
};

export default SideMenuBar;
